<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Settings</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-2">
            <h4 class="mt-2">Company</h4>
          </div>
          <div class="col-md-4">
            <select class="form-control" v-model="company" @change="changeCompany">
              <option v-for="company in companies" :key="company.CompanyName" :value="company.CompanyName">
                {{ company.CompanyName }}
              </option>
            </select>
          </div>
        </div>

        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
          <table style="width: auto !important" class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="text-center" style="width: 300px">&nbsp;</th>
                <th class="text-center" style="width: 600px">Setting Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Header Message</td>
                <td>
                  <div class="row">
                    <div class="col-10">
                      <textarea class="form-control" rows="3" v-model="setting.HeaderMessage"></textarea>
                    </div>
                    <div class="col-2">
                      <label class="mb-0" style="word-spacing: -5px; font-size: 12px">
                        Font Size (px)
                      </label>
                      <input type="number" v-model="setting.HeaderMessageFontSize" class="form-control height26" min="1"
                        max="100" step="0.1" />
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td>Attendance Payment Earned Capped</td>
                <td>
                  <input type="text" v-model="setting.AttendancePaymentEarnedCapped" placeholder="Put in 0 for no cap"
                    class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>Attendance Restriction (in Month)</td>
                <td>
                  <input type="text" v-model="setting.AttendanceRestriction" placeholder="Put in 0 for no restriction"
                    class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>Attendance New Layout Effective from</td>
                <td>
                  <input type="month" v-model="setting.AttendanceNewLayoutEffectiveDate"
                    class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>Attendance New Layout Message</td>
                <td>
                  <textarea class="form-control" rows="2" v-model="setting.AttendanceNewLayoutMessage"></textarea>
                </td>
              </tr>

              <tr>
                <td>Car Park Claim Payable Amount Capped</td>
                <td>
                  <input type="text" v-model="setting.CarparkClaimPayableAmountCapped" placeholder="Put in 0 for no cap"
                    class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>SSO Whitelisted IP Address</td>
                <td>
                  <input type="text" v-model="setting.APIWhiteListIP" class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>Instruction File for Timesheet</td>
                <td>
                  <textarea class="form-control" rows="3" v-model="setting.TimesheetInstructionFile"></textarea>
                </td>
              </tr>

              <tr>
                <td class="setting-subtitle" colspan="2">
                  <h3 class="setting-subtitle">SMTP</h3>
                </td>
              </tr>

              <tr>
                <td>SMTP Host</td>
                <td>
                  <input type="text" v-model="setting.SMTPHost" class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>SMTP Username</td>
                <td>
                  <input type="text" v-model="setting.SMTPUsername" class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>SMTP Password</td>
                <td>
                  <input type="text" v-model="setting.SMTPPassword" class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>SMTP Mode</td>
                <td>
                  <select style="width: 150px" v-model="setting.SMTPMode" class="form-control height28">
                    <option value="NONE">Not Secured</option>
                    <option value="TLS">TLS</option>
                    <option value="SSL">SSL</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td>SMTP Port</td>
                <td>
                  <input type="text" v-model="setting.SMTPPort" class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>SMTP Sender Email</td>
                <td>
                  <input type="email" v-model="setting.SMTPSenderEmail" class="form-control height26" />
                </td>
              </tr>

              <tr>
                <td>SMTP Sender Name</td>
                <td>
                  <input type="text" v-model="setting.SMTPSenderName" class="form-control height26" />
                </td>
              </tr>

              <!-- Auto Timesheet Processing -->
              <tr>
                <td class="setting-subtitle" colspan="2">
                  <h3 class="setting-subtitle">Auto Timesheet Processing</h3>
                </td>
              </tr>
              <tr>
                <td>SFTP Host</td>
                <td>
                  <input type="text" v-model="setting.ATP_SFTPHost" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>SFTP Port</td>
                <td>
                  <input type="number" v-model="setting.ATP_SFTPPort" class="form-control height26" max="999999" />
                </td>
              </tr>
              <tr>
                <td>SFTP Username</td>
                <td>
                  <input type="text" v-model="setting.ATP_SFTPUsername" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>SFTP Password</td>
                <td>
                  <input type="text" v-model="setting.ATP_SFTPPassword" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>SFTP Folder</td>
                <td>
                  <input type="text" v-model="setting.ATP_SFTPFolder" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>File Name</td>
                <td>
                  <input type="text" v-model="setting.ATP_Filename" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>Data Retention Period</td>
                <td style="display: flex">
                  <input type="number" max="999" min="1" v-model="setting.ATP_DataRetentionPeriod"
                    class="form-control height26" style="width: 150px" />
                  <span class="mt-1 ml-2">months</span>
                </td>
              </tr>
              <!-- /Auto Timesheet Processing -->

              <!-- Data Change in Insurance and Dependents Enrolment -->
              <tr>
                <td class="setting-subtitle" colspan="2">
                  <h3 class="setting-subtitle">
                    Data Change in Insurance and Dependents Enrolment
                  </h3>
                </td>
              </tr>
              <tr>
                <td>SFTP Host</td>
                <td>
                  <input type="text" v-model="setting.DCIDE_SFTPHost" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>SFTP Port</td>
                <td>
                  <input type="number" v-model="setting.DCIDE_SFTPPort" class="form-control height26" max="999999" />
                </td>
              </tr>
              <tr>
                <td>SFTP Username</td>
                <td>
                  <input type="text" v-model="setting.DCIDE_SFTPUsername" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>SFTP Password</td>
                <td>
                  <input type="text" v-model="setting.DCIDE_SFTPPassword" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>SFTP Folder</td>
                <td>
                  <input type="text" v-model="setting.DCIDE_SFTPFolder" class="form-control height26" />
                </td>
              </tr>
              <tr>
                <td>File Name</td>
                <td>
                  <input type="text" v-model="setting.DCIDE_Filename" class="form-control height26" />
                </td>
              </tr>
              <!-- /Data Change in Insurance and Dependents Enrolment -->

              <tr v-if="mode == 'edit'">
                <td></td>
                <td>
                  <button @click="saveSettings" type="button" class="btn btn-primary">
                    <i class="fa fa-save"></i> Save
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!-- Audit Log -->
    <div class="row mt-5" v-if="logs.length">
      <div class="col-md-12">
        <h4>Audit Log</h4>
      </div>
    </div>
    <div class="row mb-5" v-if="logs.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Date</th>
                <th>Login Name</th>
                <th>Full Name</th>
                <th>Email</th>
                <th>Old Data</th>
                <th>New Data</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in logs" :key="log.Id">
                <td>{{ log.DateDisplay }}</td>
                <td>{{ log.LoginName }}</td>
                <td>{{ log.FullName }}</td>
                <td>{{ log.Email }}</td>
                <td v-html="log.OldData"></td>
                <td v-html="log.NewData"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Audit Log -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  components: {},

  data() {
    return {
      company: "Lam Research Singapore Pte Ltd",
      companies: [],
      logs: [],
      setting: {
        AttendancePaymentEarnedCapped: "",
        AttendanceRestriction: "",
        AttendanceNewLayoutEffectiveDate: "",
        AttendanceNewLayoutMessage: "",
        CarparkClaimPayableAmountCapped: "",
        APIWhiteListIP: "",
        TimesheetInstructionFile: "",
        SMTPHost: "",
        SMTPUsername: "",
        SMTPPassword: "",
        SMTPPort: "",
        SMTPMode: "SSL",
        SMTPSenderEmail: "",
        SMTPSenderName: "",
        ATP_SFTPHost: "",
        ATP_SFTPPort: null,
        ATP_SFTPUsername: "",
        ATP_SFTPPassword: "",
        ATP_SFTPFolder: "",
        ATP_Filename: "",
        ATP_DataRetentionPeriod: "",
        DCIDE_SFTPHost: "",
        DCIDE_SFTPPort: null,
        DCIDE_SFTPUsername: "",
        DCIDE_SFTPPassword: "",
        DCIDE_SFTPFolder: "",
        DCIDE_Filename: "",
      },
      mode: "edit",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
            this.company = this.companies[0].CompanyName;
            this.getSettings();
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSettings() {
      let param = {
        Token: this.token,
        Company: this.company,
      };
      this.$store.state.isLoading = true;

      API.getSettings(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) {
              this.setting = response.data.record;
              this.logs = response.data.logs;
            } else {
              this.setting = {
                HeaderMessage: "",
                HeaderMessageFontSize: "",
                AttendancePaymentEarnedCapped: "",
                AttendanceRestriction: "",
                AttendanceNewLayoutEffectiveDate: "",
                AttendanceNewLayoutMessage: "",
                CarparkClaimPayableAmountCapped: "",
                APIWhiteListIP: "",
                TimesheetInstructionFile: "",
                SMTPHost: "",
                SMTPUsername: "",
                SMTPPassword: "",
                SMTPPort: "",
                SMTPMode: "SSL",
                SMTPSenderEmail: "",
                SMTPSenderName: "",
                ATP_SFTPHost: "",
                ATP_SFTPPort: null,
                ATP_SFTPUsername: "",
                ATP_SFTPPassword: "",
                ATP_SFTPFolder: "",
                ATP_Filename: "",
                ATP_DataRetentionPeriod: "",
                DCIDE_SFTPHost: "",
                DCIDE_SFTPPort: null,
                DCIDE_SFTPUsername: "",
                DCIDE_SFTPPassword: "",
                DCIDE_SFTPFolder: "",
                DCIDE_Filename: "",
              };
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }

          // console.log(response.data);
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    changeCompany() {
      this.getSettings();
    },
    saveSettings() {
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the settings?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          let param = {
            Token: this.token,
            Company: this.company,
            HeaderMessage: this.setting.HeaderMessage,
            HeaderMessageFontSize: this.setting.HeaderMessageFontSize,
            AttendancePaymentEarnedCapped:
              this.setting.AttendancePaymentEarnedCapped,
            AttendanceRestriction: this.setting.AttendanceRestriction,
            AttendanceNewLayoutEffectiveDate:
              this.setting.AttendanceNewLayoutEffectiveDate,
            AttendanceNewLayoutMessage: this.setting.AttendanceNewLayoutMessage,
            CarparkClaimPayableAmountCapped:
              this.setting.CarparkClaimPayableAmountCapped,
            APIWhiteListIP: this.setting.APIWhiteListIP,
            TimesheetInstructionFile: this.setting.TimesheetInstructionFile,
            SMTPHost: this.setting.SMTPHost,
            SMTPUsername: this.setting.SMTPUsername,
            SMTPPassword: this.setting.SMTPPassword,
            SMTPMode: this.setting.SMTPMode,
            SMTPPort: this.setting.SMTPPort,
            SMTPSenderEmail: this.setting.SMTPSenderEmail,
            SMTPSenderName: this.setting.SMTPSenderName,
            ATP_SFTPHost: this.setting.ATP_SFTPHost,
            ATP_SFTPPort: this.setting.ATP_SFTPPort,
            ATP_SFTPUsername: this.setting.ATP_SFTPUsername,
            ATP_SFTPPassword: this.setting.ATP_SFTPPassword,
            ATP_SFTPFolder: this.setting.ATP_SFTPFolder,
            ATP_Filename: this.setting.ATP_Filename,
            ATP_DataRetentionPeriod: this.setting.ATP_DataRetentionPeriod,
            DCIDE_SFTPHost: this.setting.DCIDE_SFTPHost,
            DCIDE_SFTPPort: this.setting.DCIDE_SFTPPort,
            DCIDE_SFTPUsername: this.setting.DCIDE_SFTPUsername,
            DCIDE_SFTPPassword: this.setting.DCIDE_SFTPPassword,
            DCIDE_SFTPFolder: this.setting.DCIDE_SFTPFolder,
            DCIDE_Filename: this.setting.DCIDE_Filename,
          };

          this.$store.state.isLoading = true;

          API.saveSettings(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              if (response.data.success) {
                this.$swal("Settings saved successfully!", {
                  icon: "success",
                });
                this.getSettings();
              } else {
                this.$swal(response.data.message, { icon: "error" });
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },

  created() {
    if (this.role != "admin") this.$router.replace({ name: "home" });

    this.getCompanies();
    this.getSettings();
  },
};
</script>

<style scoped>
.table {
  word-spacing: -3px;
}

.table td {
  font-size: 14px;
}

.table-responsive {
  max-height: 650px;
}
</style>


// WEBPACK FOOTER //
// src/components/System/Settings.vue